const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const Cast = require('../../util/cast');
const { fetchWithTimeout } = require('../../util/fetch-with-timeout');
const log = require('../../util/log');
const formatMessage = require('format-message');

/**
 * Icon svg to be displayed at the left edge of each extension block, encoded as a data URI.
 * @type {string}
 */
// eslint-disable-next-line max-len
const blockIconURI = 'data:image/png;base64,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';

/**
 * @typedef {{
 * answerBlockText: string,
 * answerBlockDefaultValue: string,
 * answerFuncEnterOpenAIApiKey: string,
 * clearMessageLogsBlockText: string,
 * setMaxTokensBlockText: string,
 * setTemperatureBlockText: string,
 * setApiKeyBlockText: string,
 * setApiKeyBlockDefaultValue: string,
 * setApiKeyFuncPromptText: string,
 * setSystemPromptBlockText: string,
 * answerFuncFailedToGetAnswer: string }} I18nData
 */

/**
 * @type{{ en: I18nData, ja: I18nData, ja-Hira: I18nData }}
 */
const I18n = {
    'en': {
        answerBlockText:
            '[TEXT] Answer',
        answerBlockDefaultValue:
            'How can I get better at Scratch?',
        answerFuncEnterOpenAIApiKey:
            'Enter the API key obtained from the openai.com site',
        clearMessageLogsBlockText:
            'Clear message logs',
        setMaxTokensBlockText:
            'Set max tokens [NUMBER]',
        setApiKeyBlockText:
            'Set API key',
        setTemperatureBlockText:
            'Set temperature (0-2) [NUMBER]',
        setTimeoutBlockText:
            'Set timeout [NUMBER]',
        setApiKeyBlockDefaultValue:
            'API key',
        setApiKeyFuncAzurePromptText:
            'No API key required',
        setApiKeyFuncPromptText:
            'Enter the API key.',
        setSystemPromptBlockText:
            'Set the system prompt [TEXT]',
        answerFuncFailedToGetAnswer:
            'Failed to get answer',
    },
    'ja': {
        answerBlockText:
            '[TEXT]の答え',
        answerBlockDefaultValue:
            'Scratch が上手くなるには?',
        answerFuncEnterOpenAIApiKey:
            'openai.com のサイトからAPIキーを取得してセットください',
        clearMessageLogsBlockText:
            'メッセージログをクリア',
        setMaxTokensBlockText:
            '最大トークン数を設定[NUMBER]',
        setTemperatureBlockText:
            'temperature を設定 (0-2) [NUMBER]',
        setTimeoutBlockText:
            'timeout を設定 [NUMBER]',
        setApiKeyBlockText:
            'APIキーをセット',
        setApiKeyBlockDefaultValue:
            'API キー',
        setApiKeyFuncAzurePromptText:
            'APIキーは不要です',
        setApiKeyFuncPromptText:
            'APIキーを入力してください',
        setSystemPromptBlockText:
            'システムプロンプトを設定 [TEXT]',
        answerFuncFailedToGetAnswer:
            '答えを取得できませんでした',

    },
    'ja-Hira': {
        answerBlockText:
            '[TEXT]のこたえ',
        answerBlockDefaultValue:
            'スクラッチがうまくなるには?',
        answerFuncEnterOpenAIApiKey:
            'オープンエーアイエーアイキーをにゅうりょくしてください',
        clearMessageLogsBlockText:
            'メッセージログをクリア',
        setMaxTokensBlockText:
            'さいだいトークンすうをせってい[NUMBER]',
        setTemperatureBlockText:
            'テンパラチュアをせってい (0-2) [NUMBER]',
        setTimeoutBlockText:
            'タイムアウトをせってい [NUMBER]',
        setApiKeyBlockText:
            'エーピーアイキーをセット',
        setApiKeyBlockDefaultValue:
            'エーピーアイキー',
        setApiKeyFuncAzurePromptText:
            'APIキーはふようです',
        setApiKeyFuncPromptText:
            'エーピーアイキーをにゅうりょくしてください',
        setSystemPromptBlockText:
            'システムプロンプトをせってい [TEXT]',
        answerFuncFailedToGetAnswer:
            'こたえをしゅとくできませんでした'
    }
}

const comesFromCoderDojoJapan = (() => {
    const cacheKey = 'comesFromCoderDojoJapan';
    const cacheValue = process.env.DOJO_KEY;
    const comesFromCoderDojoJapanCache = localStorage.getItem(cacheKey);
    if(comesFromCoderDojoJapanCache === cacheValue) {
        return true
    }
    const referer = document.referrer;
    if(referer === '') return false;

    const url = new URL(document.referrer);

    const allowedOrigins = [
        'https://coderdojo.jp',
        'https://coderdojo-seto.jp',
    ];

    if(allowedOrigins.some(v => url.origin === v)) {
        localStorage.setItem(cacheKey, cacheValue);
        return true;
    }
})()

/**
 * Class for the new blocks in Scratch 3.0
 * @param {Runtime} runtime - the runtime instantiating this block package.
 * @constructor
 */
class Scratch3ChatGPTBlocks {
    SESSION_STORAGE_KEY_CHATGPT_API_KEY = 'chatGptApiKey'

    constructor(runtime) {
        /**
         * The runtime instantiating this block package.
         * @type {Runtime}
         */
        this.runtime = runtime;
        this.apiKey = window.sessionStorage.getItem(this.SESSION_STORAGE_KEY_CHATGPT_API_KEY) || '';
        this.maxTokens = 300;
        this.temperature = 1;
        this.timeout = 30000;
        this.systemPrompt = 'You are a helpful assistant in the Scratch programming language.';
        this._initMessageLog();
        const currentLocale = formatMessage.setup().locale;
        const availableLocales = ['en', 'ja', 'ja-Hira',];
        /**
         * @type {I18nData}
         */
        this.i18n = I18n[availableLocales.includes(currentLocale) ? currentLocale : 'en'];
    }

    _initMessageLog() {
        this.messageLogs = [];
    }

    _getSystemPromptMessage() {
        if(this.systemPrompt === '') {
            return null;
        } else {
            return { "role": "system", "content": this.systemPrompt };
        }
    }

    /**
    * @returns {object} metadata for this extension and its blocks.
    */
    getInfo() {
        return {
            id: 'chatgpt2scratch',
            name: 'CHATGPT2Scratch',
            blockIconURI: blockIconURI,
            blocks: [
                {
                    opcode: 'answer',
                    blockType: BlockType.REPORTER,
                    text: this.i18n.answerBlockText,
                    arguments: {
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: this.i18n.answerBlockDefaultValue,
                        }
                    }
                },
                {
                    opcode: 'clearMessageLogs',
                    blockType: BlockType.COMMAND,
                    text: this.i18n.clearMessageLogsBlockText,

                },
                {
                    opcode: 'setMaxTokens',
                    blockType: BlockType.COMMAND,
                    text: this.i18n.setMaxTokensBlockText,
                    arguments: {
                        NUMBER: {
                            type: ArgumentType.NUMBER,
                            defaultValue: this.maxTokens
                        }
                    }
                },
                {
                    opcode: 'setTemperature',
                    blockType: BlockType.COMMAND,
                    text: this.i18n.setTemperatureBlockText,
                    arguments: {
                        NUMBER: {
                            type: ArgumentType.NUMBER,
                            defaultValue: this.temperature
                        }
                    }
                },
                {
                    opcode: 'setTimeout',
                    blockType: BlockType.COMMAND,
                    text: this.i18n.setTimeoutBlockText,
                    arguments: {
                        NUMBER: {
                            type: ArgumentType.NUMBER,
                            defaultValue: this.timeout
                        }
                    }
                },
                {
                    opcode: 'setSystemPrompt',
                    blockType: BlockType.COMMAND,
                    text: this.i18n.setSystemPromptBlockText,
                    arguments: {
                        TEXT: {
                            type: ArgumentType.STRING,
                            defaultValue: this.systemPrompt
                        }
                    }
                },
                {
                    opcode: 'setApiKey',
                    blockType: BlockType.COMMAND,
                    text: this.i18n.setApiKeyBlockText,
                }
            ],
        };
    }

    answer(args) {
        if (!this.hasApiKey()){
            return this.i18n.answerFuncEnterOpenAIApiKey
        }

        const question = Cast.toString(args.TEXT);
        if (question === this._lastQuestion) {
            return this._lastAnswer
        }

        const questionMessageLog = { "role": "user", "content": question }
        const params = {
            method: 'POST',
            headers: this.requestHeader,
            body: JSON.stringify({
                model: "gpt-4o-mini",
                messages: [
                    this._getSystemPromptMessage(),...this.messageLogs, questionMessageLog
                ].filter( v => v !== null),
                max_tokens: this.maxTokens,
                temperature: this.temperature,
            })
        }
        const completionPromise = fetchWithTimeout(this.apiUrl, params, this.timeout)
            .then(response => response.json()
            ).then(json => {
                if(json.error !== undefined) {
                    return `[${json.error.code}: ${json.error.type}] ${json.error.message}`
                }
                this._lastAnswer = json.choices[0].message.content
                this._lastQuestion = question
                this.messageLogs.push(questionMessageLog)
                this.messageLogs.push({ role: "assistant", content: this._lastAnswer })
                return (this._lastAnswer)
            }).catch(error => {
                log.warn(error);
                return (`${this.i18n.answerFuncFailedToGetAnswer} | ${error}`);
            });

        return completionPromise;
    }

    clearMessageLogs() {
        this._lastAnswer = '';
        this._lastQuestion = '';
        this._initMessageLog();
    }

    setApiKey() {
        if(comesFromCoderDojoJapan) {
            alert(this.i18n.setApiKeyFuncAzurePromptText);
        } else {
            this.apiKey = window.prompt(this.i18n.setApiKeyFuncPromptText);
            window.sessionStorage.setItem(this.SESSION_STORAGE_KEY_CHATGPT_API_KEY, this.apiKey);
        }
    }

    hasApiKey() {
        if(comesFromCoderDojoJapan) return true;
        if(this.apiKey === '') return false;

        return this.apiKey !== this.i18n.setApiKeyBlockDefaultValue
    }

    get apiUrl() {
        let url;
        if(comesFromCoderDojoJapan) {
            url = 'https://chatgpt2scratch.openai.azure.com/openai/deployments/gpt-4o-mini/chat/completions?api-version=2024-08-01-preview'
        } else {
            url = 'https://api.openai.com/v1/chat/completions'
        }
        return url;
    }

    get requestHeader() {
        const header = {
            'Content-Type': 'application/json',
        }
        if(comesFromCoderDojoJapan) {
            header['api-key'] = process.env.AZURE_API_KEY;
        } else {
            header['Authorization'] = `Bearer ${this.apiKey}`
        }
        return header;
    }

    setMaxTokens(args) {
        this.maxTokens = Number(args.NUMBER);
    }

    setTemperature(args) {
        this.temperature = Number(args.NUMBER);
    }

    setTimeout(args) {
        this.timeout = Number(args.NUMBER);
    }

    setSystemPrompt(args) {
        this.systemPrompt = Cast.toString(args.TEXT);
    }
}

module.exports = Scratch3ChatGPTBlocks;
